<template>
  <div class="developer">
    <div class="part-1">
      <p class="tit">{{ $t('applyDeveloper.head') }}</p>
    </div>
    <div class="part-2">
      <div class="main">
        <!--姓名 性别-->
        <Form ref="form" :model="form" :rules="rules" :label-width="140"   class="form">
          <FormItem prop="name" :label="$t('applyDeveloper.name')">
            <span class="x">*</span>
            <Input
              v-model="form.name"
              :maxlength="32"
              :placeholder="$t('applyDeveloper.nameTip')"
              style="width:45%;display:inline-block;vertical-align:middle;"
            ></Input>
            <div
              class="label_box"
              style="display:inline-block;vertical-align:top;margin-left:30px;"
            >
              <label style>
                <input name="form.sex" type="radio" value="1" checked />
                <div>{{ $t('applyDeveloper.man') }}</div>
              </label>
              <label style="float:right;margin-right:0px;">
                <input name="form.sex" type="radio" value="2" />
                <div>{{ $t('applyDeveloper.woman') }}</div>
              </label>
            </div>
          </FormItem>

          <!--身份-->
          <FormItem :label="$t('applyDeveloper.identity')" style="height:38px;">
            <span class="x" style="vertical-align:top;">*</span>
            <div class="label_box">
              <label>
                <input name="form.type" type="radio" value="1" checked @click="gs" />
                <div>{{ $t('applyDeveloper.company') }}</div>
              </label>
              <label style="float:right;margin-right:0px;">
                <input name="form.type" type="radio" value="2" @click="gr" />
                <div>{{ $t('applyDeveloper.person') }}</div>
              </label>
            </div>
          </FormItem>
          <!--地址-->
          <div style="height:60px">
            <FormItem
              prop="countryId"
              :label="$t('applyDeveloper.city')"
              style="display:inline-block;width:500px"
            >
              <span class="x">*</span>
              <Select
                v-model="form.countryId"
                style="width:340px;"
                :placeholder="$t('applyDeveloper.countryTip')"
              >
                <Option v-for="item in countryList" :value="item.id" :key="item.id">{{ item.name }}</Option>
              </Select>
            </FormItem>
            <FormItem style="display:inline-block;width:300px;margin-left:-115px" prop="city">
              <Input
                v-model="form.city"
                :maxlength="30"
                style="width:340px;"
                :placeholder="$t('applyDeveloper.cityTip')"
              ></Input>
            </FormItem>
          </div>
          <!--公司部分-->
          <FormItem prop="companyName" :label="$t('applyDeveloper.companyName')" v-if="cpname">
            <span class="x">*</span>
            <Input v-model="form.companyName" :maxlength="50"></Input>
          </FormItem>

          <FormItem
            prop="companyAddress"
            :label="$t('applyDeveloper.companyAddress')"
            v-if="cpadd"
          >
            <span class="x">*</span>
            <Input v-model="form.companyAddress" :maxlength="80"></Input>
          </FormItem>
          <FormItem prop="email" :label="$t('applyDeveloper.email')">
            <span class="x">*</span>
            <Input v-model="form.email" :maxlength="50"></Input>
          </FormItem>
          <!--验证码-->
          <FormItem prop="emailCode" :label="$t('applyDeveloper.emailCode')">
            <span class="x">*</span>
            <Input v-model="form.emailCode" :maxlength="6" style="width:70%;"></Input>
            <Button
              type="primary"
              class="yzm"
              @click="setSms "
              :loading="loading1"
              ghost
              v-show="botton1"
            >{{ $t('applyDeveloper.getCode') }}</Button>
            <Button
              type="primary"
              class="yzm"
              :loading="loading1"
              disabled
              ghost
              v-show="botton2"
            >{{ content }}</Button>
          </FormItem>
          <FormItem prop="description" :label="$t('applyDeveloper.description')">
            <span class="x">*</span>
            <Input v-model="form.description" :maxlength="50"></Input>
          </FormItem>

          <!--<FormItem v-if="successTip">
            <span style="color:#e00;">{{ $t('applyDeveloper.tip') }}</span>
          </FormItem>-->
          <FormItem>
            <Button
              type="primary"
              @click="handleSubmit('form')"
              :loading="loading2"
              style="margin-left:18px;font-size:20px;border-radius:0;font-weight:400;
color:rgba(255,255,255,1);background-color:#3A88F7;"
            >{{ $t('applyDeveloper.apply') }}</Button>
          </FormItem>
          <Modal
            v-model="modal1"
            :closable="false"
            :title="$t('applyDeveloper.successtitle') "
            cancel-text
            :ok-text="$t('applyDeveloper.confirm')"
          >
            <p>{{ $t('applyDeveloper.tip') }}</p>
          </Modal>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Form,
  FormItem,
  Input,
  Select,
  Option,
  RadioGroup,
  Radio,
  Button,
  Modal
} from "iview";
import api from "../common/api";
import validate from "../utils/validate";

export default {
  name: "developerapplication",

  components: {
    Form,
    FormItem,
    Input,
    Select,
    Option,
    RadioGroup,
    Radio,
    Button,
    Modal
  },

  data() {
    const validateName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("applyDeveloper.nameTip")));
      } else {
        callback();
      }
    };

    const validateCountryId = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("applyDeveloper.countryTip")));
      } else {
        callback();
      }
    };

    const validateCity = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("applyDeveloper.cityTip")));
      } else {
        callback();
      }
    };

    const validateEmail = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("applyDeveloper.emailTip")));
      } else if (!validate.email(value)) {
        callback(new Error(this.$t("applyDeveloper.emailValid")));
      } else {
        callback();
      }
    };

    const validateEmailCode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("applyDeveloper.emailCodeTip")));
      } else {
        callback();
      }
    };

    const validateDescription = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("applyDeveloper.descriptionTip")));
      } else {
        callback();
      }
    };

    const validateCompanyName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("applyDeveloper.companyNameTip")));
      } else {
        callback();
      }
    };
    const validateCompanyAddress = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("applyDeveloper.companyAddressTip")));
      } else {
        callback();
      }
    };

    return {
      countryList: [],
      cityList: [],
      cpname: true,
      cpadd: true,
      content: "",
      totalTime: 60,
      canClick: true,
      botton1: true,
      botton2: false,

      //modal1:false,
      form: {
        name: "",
        sex: 1,
        countryId: "",
        city: "",
        type: 1,
        companyName: "",
        companyAddress: "",
        email: "",
        emailCode: "",
        description: ""
      },
      rules: {
        name: [{ validator: validateName, trigger: "change" }],
        countryId: [{ validator: validateCountryId, trigger: "change" }],
        city: [{ validator: validateCity, trigger: "change" }],
        companyName: [{ validator: validateCompanyName, trigger: "change" }],
        companyAddress: [{ validator: validateCompanyAddress, trigger: "change" }],
        email: [{ validator: validateEmail, trigger: "change" }],
        emailCode: [{ validator: validateEmailCode, trigger: "change" }],
        description: [{ validator: validateDescription, trigger: "change" }]
      },

      loading1: false,
      loading2: false,
      successTip: false,
      modal1: false,
    };
  },

  created() {
    this.getCountryList();
  },

  methods: {
    getCountryList() {
      this.$axios
        .get(`${api.getCountryList}`)
        .then(res => {
          this.countryList = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },

    gs() {
      this.cpname = true;
      this.cpadd = true;
    },
    gr() {
      this.cpname = false;
      this.cpadd = false;
    },

    //ok(){
    //this.$Message.info('Clicked ok');
    //},
    //cancel(){
    // this.$Message.info('Clicked cancel');
    //},

    setSms() {
      if (this.form.email == "") {
        this.$Message.error(this.$t("applyDeveloper.emailTip"));
        return false;
      }
      if (!validate.email(this.form.email)) {
        this.$Message.error(this.$t("applyDeveloper.emailValid"));
        return false;
      }
      this.loading1 = true;
      this.$axios
        .post(`${api.sendSms}`, {
          email: this.form.email
        })
        .then(res => {
          this.loading1 = false;
          this.botton1 = false,
          this.botton2 = true,
          this.canClick = false;
          this.content = this.totalTime + "s";
          let clock = window.setInterval(() => {
            this.totalTime--;
            this.content = this.totalTime + "s";
            if (this.totalTime < 0) {
              this.botton2 = false,
              this.botton1 = true,
              window.clearInterval(clock);
              this.content = "";
              this.totalTime = 60;
              this.canClick = true;
            }
          }, 1000);
          this.$Message.success(this.$t("applyDeveloper.emailCodeSuccess"));
        })
        .catch(err => {
          this.loading1 = false;
          this.$Message.error(err.message);
        });
      if (!this.canClick) return;
      
    },

    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.loading2 = true;
          this.$axios
            .post(`${api.applyDeveloper}`, {
              name: this.form.name,
              sex: this.form.sex,
              countryId: this.form.countryId,
              city: this.form.city,
              type: this.form.type,
              companyName: this.form.companyName,
              companyAddress: this.form.companyAddress,
              email: this.form.email,
              emailCode: this.form.emailCode,
              description: this.form.description
            })
            .then(res => {
              this.loading2 = false;
              this.successTip = true;
              this.modal1 = true;
              this.$refs["form"].resetFields();
            })
            .catch(err => {
              this.loading2 = false;
              this.$Message.error(err.message);
            });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import url("../assets/css/var.less");
 
.ivu-modal-footer {
  display: none !important;
}

.developer {
  .part-1 {
    height: 300px;
    background-image: url("../assets/images/developer-appli-bg.jpg");
    background-repeat: no-repeat;
    background-position: top;
    .tit {
      color: #ffffff;
      font-size: 38px ;
      position: absolute;
      left: 25%;
      top: 150px;
    }
  }

  .part-2 {
    .fenge {
      .fgx();
    }
    .form {
      width: 80%;
      margin: 0 auto;
      margin-top: 40px;
    }

    .yzm {
      height: 38px;
      margin-left: 5%;
      width: 20%;
      position: absolute;
      //right: 0;
      top: 1px;
      color: #5e9eca;
      border: 1px solid #dfe0e4;
      border-radius: 0;
      background: #f2f5fa;
      padding: 0;
      font-size: 16px;
      font-weight: 400;
    }
  }
}
/*下拉框*/
/deep/ input::-webkit-input-placeholder {
  /* placeholder颜色  */
  color: #c5c8ce;
  /* placeholder字体大小  */
  font-size: 16px;
  /* placeholder位置  */
  text-align: left;
}
/deep/.ivu-select-item {
  font-size: 16px !important;
}

/deep/.ivu-select-single .ivu-select-selection .ivu-select-selected-value {
  font-size: 16px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  padding: 4px 0 0 20px;
}

/deep/ .ivu-input {
  border-radius: 2px;
  color: #666;
  text-indent: 0;
  width: 100%;
  height: 38px;
  font-size: 16px;

  font-weight: 400;
  color: rgba(153, 153, 153, 1);
}

/deep/ .ivu-select-selection {
  border-radius: 2px;
  height: 38px;
  /deep/ .ivu-select-placeholder {
    line-height: 38px;
    padding-left: 22px;
    font-size: 16px;

    font-weight: 400;
    color: rgba(153, 153, 153, 0.6);
  }
}
/deep/ .ivu-btn-primary {
  padding: 6px 60px;
}

//自定义单选框 开始

.label_box {
  display: inline-block;
  width: 45%;
}
.label_box > label {
  display: inline-block;
  float: left;
  margin: 0 10px 10px 0;
  position: relative;
  overflow: hidden;
  width: 45%;
}

.label_box > label > input {
  position: absolute;
  top: 0;
  left: -20px;
}

.label_box > label > div {
  width: 100%;
  text-align: center;
  border: #e6e4e4 solid 1px;
  height: 38px;
  line-height: 38px;
  color: #666666;
  user-select: none;
  overflow: hidden;
  position: relative;
  background-color: #fff;
  font-size: 16px;
  cursor: pointer;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
}

.label_box > label > input:checked + div {
  border: rgba(76, 143, 255, 1) solid 1px;
  font-size: 16px;
  font-weight: 400;
  color: rgba(76, 143, 255, 1);
}

.label_box > label > input:checked + div:after {
  content: "";
  display: block;
  width: 100%;
  height: 100%;
  background-color: rgba(38, 115, 191, 0.1);
  //transform: skewY(-45deg);
  position: absolute;
  bottom: 0px;
  right: 0;
  z-index: 1;
}

.label_box > label > input:checked + div:before {
  content: "";
  display: block;
  width: 3px;
  height: 8px;
  //border-right: #ffffff solid 2px;
  //border-bottom: #ffffff solid 2px;
  transform: rotate(35deg);
  position: absolute;
  bottom: 2px;
  right: 4px;
  z-index: 2;
}

//自定义单选框 结束
/deep/ .ivu-form .ivu-form-item-label {
  padding: 10px 5px 10px 0;
  font-size: 16px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
/deep/ .ivu-input-wrapper {
  width: 95%;
}

/deep/ .ivu-btn-primary {
  padding: 11px 60px;
}
/deep/.ivu-modal {
  top: 40%;
}
.x {
  display: inline-block;
  color: #ff2626;
  margin-right: 12px;
}
.x1 {
  color: white;
  margin-right: 12px;
  border-radius: 0;
}
//弹框
/deep/.ivu-modal-header {
  width: 520px;
  height: 60px;
  padding: 20px 16px;
}
/deep/ .ivu-modal-header-inner {
  font-size: 20px;

  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  text-align: center;
}
/deep/.ivu-modal-body {
  height: 126px;
  font-size: 16px;
  font-weight: 400;
  color: rgba(85, 85, 85, 1);
  line-height: 95px;
  text-align: center;
}
/deep/.ivu-modal-footer {
  padding-right: 35%;
  padding-top: 20px;
  padding-bottom: 20px;
}

/*提示*/
/deep/.ivu-form-item-error-tip {
  left: 20px;
}
/deep/.ivu-form-item-content{
  height:38px;
}
</style>
